

































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import CancelledReason from '@/models/Shared/CancelledReason';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import CancelShiftViewModel from '@/models/Shifts/CancelShiftViewModel';

@Component({
    name: 'ShiftCancel'
})
export default class ShiftCancel extends GiganautVueDialog {
 
  cancelledReason: CancelledReason = CancelledReason.CANCELLED_REASON_REQUIREMENTS_CHANGED;
  cancelledText = '';
  @Prop({required: true})
	shiftId: string;
  @Prop({required: true})
	bookingRoleId: string;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.cancelledText = '';
      this.cancelledReason = CancelledReason.CANCELLED_REASON_REQUIREMENTS_CHANGED;
    }
  }

  get cancelledReasons() {
    return ListUtils.cancelledReasonsForBooker();
  }

  get cancellationDisabled () {
    return this.cancelledText !== 'CANCEL'
  }


  async confirm() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const vm = new CancelShiftViewModel()
    vm.updatedAt = BookingDetailsModule.currentBooking.updatedAt;
    vm.cancelledReason = this.cancelledReason;
    vm.shiftId = this.shiftId;
    vm.bookingRoleId = this.bookingRoleId;
    
    await BookingDetailsModule.cancelShift(vm)
    await BookingDetailsModule.updateOfferedSelectedBookingRole(BookingDetailsModule.selectedBookingRole);
    await BookingDetailsModule.updateBookedSelectedBookingRole(BookingDetailsModule.selectedBookingRole);
    this.dialog = false;
  }
}
